/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityNotificationsResult } from './MonitEntityNotificationsResult';
import {
    MonitEntityNotificationsResultFromJSON,
    MonitEntityNotificationsResultFromJSONTyped,
    MonitEntityNotificationsResultToJSON,
} from './MonitEntityNotificationsResult';

/**
 * 
 * @export
 * @interface MonitPaginatedGetEntityNotificationsResponse
 */
export interface MonitPaginatedGetEntityNotificationsResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedGetEntityNotificationsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedGetEntityNotificationsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedGetEntityNotificationsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityNotificationsResult>}
     * @memberof MonitPaginatedGetEntityNotificationsResponse
     */
    results?: Array<MonitEntityNotificationsResult>;
}

/**
 * Check if a given object implements the MonitPaginatedGetEntityNotificationsResponse interface.
 */
export function instanceOfMonitPaginatedGetEntityNotificationsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedGetEntityNotificationsResponseFromJSON(json: any): MonitPaginatedGetEntityNotificationsResponse {
    return MonitPaginatedGetEntityNotificationsResponseFromJSONTyped(json, false);
}

export function MonitPaginatedGetEntityNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedGetEntityNotificationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityNotificationsResultFromJSON)),
    };
}

export function MonitPaginatedGetEntityNotificationsResponseToJSON(value?: MonitPaginatedGetEntityNotificationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityNotificationsResultToJSON)),
    };
}

